module.exports = __webpack_public_path__ + "5ab2596a2ff421b6efd35c8c6d6d4c44.webp";